// This file is autogenerated from /frontend/sail-next/packages/docs/src/markdoc/demo/Badge.js with go/sail-next-tailor-docs-publisher 

import React from 'react';
import { Badge } from '@sail/ui';
const basic = {
  rendered: <>
      <Badge>Neutral</Badge>
      <Badge type="info">Info</Badge>
      <Badge type="positive">Positive</Badge>
      <Badge type="negative">Negative</Badge>
      <Badge type="warning">Warning</Badge>
      <Badge type="urgent">Urgent</Badge>
    </>,
  source: `<Badge>
  Neutral
</Badge>

<Badge type="info">
  Info
</Badge>

<Badge type="positive">
  Positive
</Badge>

<Badge type="negative">
  Negative
</Badge>

<Badge type="warning">
  Warning
</Badge>

<Badge type="urgent">
  Urgent
</Badge>`
};
export const BadgeExamples = {
  basic
};